import { render, staticRenderFns } from "./talks.vue?vue&type=template&id=128e4819&"
import script from "./talks.vue?vue&type=script&lang=js&"
export * from "./talks.vue?vue&type=script&lang=js&"
import style0 from "./talks.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "talks.vue"
export default component.exports